import styled from 'styled-components';

// TODO fixa font-properties nedan! Tema etc.
const heading = `

  @media (min-width: 1300px) {
    white-space: normal;
  }

  & * {
    vertical-align: baseline;
  }
`;

export const _SelectWrapper = styled.div`
  font-family: aktiv-grotesk, sans-serif;

  .heading {
    ${heading}
  }

  // Override Scensum styling
  label {
    float: none !important;
  }

  select {
    display: block;
    width: 100%;
    margin-top: 5px;
    border: 1px solid #2e2e2e;
    padding: 10px 15px;
    font-size: 1em;
    outline: none;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: url("data:image/svg+xml;utf8,<svg fill='%23666666' height='34' viewBox='0 0 24 24' width='34' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-position-y: 50%;
    background-position-x: 98%;
    background-repeat: no-repeat;
    height: 50px;
    margin-bottom: 15px;

    &:active,
    &:focus {
      outline: 1px solid ${({ theme }) => theme.primary};
    }
  }
`;
